export type SettlementAmountLine = {
  systemId: string;
  amount: number | null;
  directUnitCost: number | null;
  quantity: number | null;
};

const roundMoney = (value: number) => Math.round(value * 100) / 100;

export function getSettlementLineAmount(
  line: SettlementAmountLine, original?: SettlementAmountLine,
): number {
  const initial = Number(original?.amount ?? line.amount ?? line.directUnitCost ?? 0);
  if (!original || original.directUnitCost === line.directUnitCost) return roundMoney(initial);
  const difference = Number(line.directUnitCost ?? 0) - Number(original.directUnitCost ?? 0);
  return roundMoney(initial + difference * Number(line.quantity ?? original.quantity ?? 1));
}

export function sumSettlementAmounts(
  lines: SettlementAmountLine[], originals: SettlementAmountLine[], pending = 0,
): number {
  const source = new Map(originals.map((line) => [line.systemId, line]));
  return roundMoney(lines.reduce(
    (total, line) => total + getSettlementLineAmount(line, source.get(line.systemId)), pending));
}
